import { render, staticRenderFns } from "./SolicitudAlta.vue?vue&type=template&id=329409ca&scoped=true"
import script from "./SolicitudAlta.vue?vue&type=script&lang=js"
export * from "./SolicitudAlta.vue?vue&type=script&lang=js"
import style0 from "./SolicitudAlta.vue?vue&type=style&index=0&id=329409ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329409ca",
  null
  
)

export default component.exports